export default __webpack_public_path__ + "static/media/dashboard.a6f89537.svg";